var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-legend"},[_c('GraphLegendPercentage',{attrs:{"value":_vm.legend.percentage,"color":_vm.legend.color}}),_c('GraphLegendLabel',{attrs:{"label":_vm.legend.label}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }